import { userConstants } from 'store/constants';
import { userService } from 'store/services/user.service';
import { history } from 'store/helpers';
import { alertsActions } from './alerts.actions';
import { webSocketActions } from 'store/actions/websocket.actions';
import { isLoggedIn } from 'store/helpers/isLoggedIn';
import { WorkdeskFilter } from 'store/models/WorkdeskFilter';
import { Ticket } from 'store/models/Ticket';
import { showOverlayActions } from './show-overlay.actions';
import getErrorMessage from 'utils/getErrorMessage';
import { workdeskTicketsActions } from './workdesk-tickets.actions';
import { userDataSelector } from 'store/selectors';
import { CEParamsI } from 'store/helpers/SearchParamsHelper';

const login = (
  tokenId: string,
  profile: { imageUrl: string; email: string; name: string },
  CEParams: CEParamsI,
) => {
  const { fromCE, inbox } = CEParams;
  const request = (user) => {
    return { type: userConstants.LOGIN_REQUEST, payload: { user } };
  };
  const success = (user) => {
    return { type: userConstants.LOGIN_SUCCESS, payload: { user } };
  };
  const failure = (error) => {
    return { type: userConstants.LOGIN_ERROR, payload: { error } };
  };
  return async (dispatch, getState) => {
    dispatch(request({ token: tokenId }));
    try {
      const token = await userService.login(tokenId, profile.email);
      const combinedUserProfile = { ...profile, token };
      localStorage.setItem(
        'user',
        JSON.stringify(combinedUserProfile),
      );
      await Promise.all([
        dispatch(success(combinedUserProfile)),
        dispatch(updateMeInfo()),
      ]);

      const { ticket } = getState();
      const ticketId =
        ticket?.data?.id ||
        Ticket.getViewingTicketIdFromLocalStorage();
      console.warn('login -> redirecting to ticketId', ticketId);
      if (ticketId) {
        let navigateTo = `/main/${ticketId}`;
        if (fromCE && !inbox) {
          console.error('if fromCE is true, inbox is required');
        } else if (fromCE && inbox) {
          navigateTo = `/main/${ticketId}?fromCE=true&inbox=${inbox}`;
        }
        history.push(navigateTo);
      } else {
        history.push(`/workdesk`);
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

const reviveUserFromLocalStorage = () => {
  return async (dispatch) => {
    const isLoggedInVal = isLoggedIn();
    console.debug(
      `in reviveUserFromLocalStorage. isLoggedInVal: `,
      isLoggedInVal,
    );
    if (!isLoggedInVal) {
      dispatch({
        type: userConstants.LOGOUT,
      });
    } else {
      const user = localStorage.getItem('user');
      const userP = JSON.parse(user as string);

      if (userP) {
        await Promise.all([
          dispatch({
            type: userConstants.LOGIN_SUCCESS,
            payload: { user: JSON.parse(user as string) },
          }),
          dispatch(updateMeInfo()),
        ]);
      }
    }
  };
};

const logout = (
  withClearUserFromLocal = true,
  withClearFilterAndTicketIdFromLocal = true,
) => {
  if (withClearUserFromLocal) {
    localStorage.removeItem('user');
  }
  if (withClearFilterAndTicketIdFromLocal) {
    Ticket.clearViewingTicketIdFromLocalStorage();
    WorkdeskFilter.clearFromLocalStorage();
  }
  return (dispatch) => {
    dispatch(showOverlayActions.closeAll());
    dispatch(webSocketActions.wsDisconnect());
    dispatch(workdeskTicketsActions.reset());
    dispatch({
      type: userConstants.LOGOUT,
    });
    // window.location.reload();
    history.push('/login');
  };
};

const updateMeInfo = () => {
  const request = () => {
    return { type: userConstants.ME_INFO_REQUEST };
  };
  const success = (data) => {
    return { type: userConstants.ME_INFO_SUCCESS, payload: { data } };
  };
  const failure = (error) => {
    return { type: userConstants.ME_INFO_ERROR, payload: { error } };
  };
  return async (dispatch, getState) => {
    dispatch(request());
    try {
      const data = await userService.meInfo();
      if (data) {
        const { userId, ...rest } = data;
        const toUpdateData = { id: userId, ...rest };
        dispatch(success(toUpdateData));
        // update in local storage
        const user = {
          ...userDataSelector(getState()),
          ...toUpdateData,
        };
        localStorage.setItem('user', JSON.stringify(user));
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

export const userActions = {
  login,
  reviveUserFromLocalStorage,
  logout,
  updateMeInfo,
};
